export default "__VITE_ASSET__Dj4iWFGo__"